import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import './NuevoDashboard.css';

const DashboardVentasMes = ({ dataVentasPorSemana, MesActual }) => {
    const tieneDatos = dataVentasPorSemana && 
                      dataVentasPorSemana.respuesta && 
                      Array.isArray(dataVentasPorSemana.respuesta) && 
                      dataVentasPorSemana.respuesta.length > 0;
    
    if (!tieneDatos) {
        return (
            <div className="dashboard-container">
                <div className="loading-state">
                    <div className="spinner"></div>
                    <h3>Cargando datos de ventas...</h3>
                </div>
            </div>
        );
    }

    const respuestaData = dataVentasPorSemana.respuesta;
    const estadisticas = dataVentasPorSemana.estadisticas && dataVentasPorSemana.estadisticas[0] 
        ? dataVentasPorSemana.estadisticas[0] 
        : {};

    const salesData = respuestaData.map(semana => ({
        semana: `${semana.Semana}`,
        ventas: parseFloat(semana.Ventas || 0),
        compras: parseFloat(semana.Compras || 0),
        cantidadVentas: parseInt(semana.CantidadVentas || 0),
        cantidadCompras: parseInt(semana.CantidadCompras || 0)
    }));

    const Balance = (parseFloat(estadisticas.TotalVentas || 0) - parseFloat(estadisticas.TotalCompras || 0)).toFixed(2);

    return (
        <div className="dashboard-container">
            <div className="dashboard-header">
                <h2 className="text-center">Dashboard de Ventas - {MesActual}</h2>
                <div className="header-stats">
                    <div className="stat-card primary">
                        <span className="stat-label">Total Ventas</span>
                        <span className="stat-value">S/ {parseFloat(estadisticas.TotalVentas || 0).toFixed(2)}</span>
                    </div>
                    <div className="stat-card secondary">
                        <span className="stat-label">Total Compras</span>
                        <span className="stat-value">S/ {parseFloat(estadisticas.TotalCompras || 0).toFixed(2)}</span>
                    </div>
                    <div className={`stat-card ${Balance >= 0 ? 'success' : 'danger'}`}>
                        <span className="stat-label">Balance</span>
                        <span className="stat-value">S/ {Balance}</span>
                    </div>
                </div>

                <div className="header-stats">
                    <div className="stat-card info">
                        <span className="stat-label">Total Transacciones Ventas</span>
                        <span className="stat-value">{estadisticas.TotalCantidadVentas || 0}</span>
                    </div>
                    <div className="stat-card dark">
                        <span className="stat-label">Total Transacciones Compras</span>
                        <span className="stat-value">{estadisticas.TotalCantidadCompras || 0}</span>
                    </div>
                </div>
            </div>

            <div className="dashboard-content">
                <div className="chart-container">
                    <h3>Ventas y Compras por Semana</h3>
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                            data={salesData}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="semana" />
                            <YAxis tickFormatter={(value) => `S/ ${value}`}/>
                            <Tooltip            
                                formatter={(value, name) => {
                                    if (name === 'ventas' || name === 'compras') {
                                        return [`S/ ${value.toFixed(2)}`, name === 'ventas' ? 'Ventas' : 'Compras'];
                                    }
                                    return [value, name];
                                }}
                            />
                            <Legend />
                            <Bar dataKey="ventas" fill="#4CAF50" name="Ventas" />
                            <Bar dataKey="compras" fill="#F44336" name="Compras" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                <div className="chart-container">
                    <h3>Cantidad de Transacciones por Semana</h3>
                    <ResponsiveContainer width="100%" height={400}>
                        <BarChart
                            data={salesData}
                            margin={{
                                top: 20,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="semana" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="cantidadVentas" fill="#2196F3" name="Transacciones Ventas" />
                            <Bar dataKey="cantidadCompras" fill="#9C27B0" name="Transacciones Compras" />
                        </BarChart>
                    </ResponsiveContainer>
                </div>

                <div className="stats-highlights">
                    <div className="highlight-card">
                        <h4 className="text-center">Máximo y Mínimo</h4>
                        <div className="highlight-content">
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMayorVenta}</span>
                                <span className="highlight-label">Mayor Venta</span>
                                <span className="highlight-value sales">S/ {parseFloat(estadisticas.MayorVenta || 0).toFixed(2)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MayorCantidadVentas || 0}</span>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMayorCompra}</span>
                                <span className="highlight-label">Mayor Compra</span>
                                <span className="highlight-value sales">S/ {parseFloat(estadisticas.MayorCompra || 0).toFixed(2)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MayorCantidadCompras || 0}</span>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMenorVenta}</span>
                                <span className="highlight-label">Menor Venta</span>
                                <span className="highlight-value purchases">S/ {parseFloat(estadisticas.MenorVenta || 0).toFixed(2)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MenorCantidadVentas || 0}</span>
                            </div>
                            <div className="highlight-item">
                                <span className="highlight-label">{estadisticas.SemanaMenorCompra}</span>
                                <span className="highlight-label">Menor Compra</span>
                                <span className="highlight-value purchases">S/ {parseFloat(estadisticas.MenorCompra || 0).toFixed(2)}</span>
                                <span className="highlight-label">Cantidad</span>
                                <span className="highlight-value info">{estadisticas.MenorCantidadCompras || 0}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="weekly-breakdown">
                    <h3 className="text-center">Desglose Semanal Completo</h3>
                    <div className="weekly-cards">
                        {salesData.map((item, index) => {
                            const weeklyBalance = (item.ventas - item.compras).toFixed(2);
                            return (
                                <div key={index} className="week-card">
                                    <h4 className="text-center">{item.semana}</h4>
                                    <div className="week-stats">
                                        <div className="week-stat">
                                            <span className="week-label">Ventas</span>
                                            <span className="week-value sales">S/ {item.ventas.toFixed(2)}</span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Compras</span>
                                            <span className="week-value purchases">S/ {item.compras.toFixed(2)}</span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Balance</span>
                                            <span className={`week-value ${weeklyBalance >= 0 ? 'positive' : 'negative'}`}>
                                                S/ {weeklyBalance}
                                            </span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Trans. Ventas</span>
                                            <span className="week-value info">{item.cantidadVentas}</span>
                                        </div>
                                        <div className="week-stat">
                                            <span className="week-label">Trans. Compras</span>
                                            <span className="week-value dark">{item.cantidadCompras}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardVentasMes;